import { Typography } from '@mui/material';
import { useContext } from 'react';
import { DATA_TEST } from './enums';
import { ResultContext, sizeStyles } from './ResultContext';
import type { ResultSubTitleProps } from './types';

/**
 * Renders the subtitle for the Result component, with responsive typography and color.
 */
export const ResultSubTitle = ({ children, dataTest, ...props }: ResultSubTitleProps) => {
  const context = useContext(ResultContext);
  if (!context) throw new Error('SubHeader must be used within an Result component');

  const { size, isMobile } = context;
  const { subTitleSize, spacing } = sizeStyles(size, isMobile);

  return (
    <Typography
      variant={subTitleSize}
      sx={{ color: 'text.disabled', marginTop: spacing }}
      data-test={dataTest ?? DATA_TEST.result_subtitle}
      {...props}
    >
      {children}
    </Typography>
  );
};
